import HomePage from "@/pages/HomePage.vue"
import StartPage from "@/pages/StartPage.vue"
import MemberPage from "@/pages/MemberPage.vue"
import MemberEdit from "@/pages/MemberEdit.vue"
import ProjectPage from "@/pages/ProjectPage.vue"
import ProjectEdit from "@/pages/ProjectEdit.vue"
import CompanyPage from "@/pages/CompanyPage.vue"
import CompanyEdit from "@/pages/CompanyEdit.vue"
import ReportPage from "@/pages/ReportPage.vue"
import ReportEdit from "@/pages/ReportEdit.vue"
import SettingPage from "@/pages/SettingPage.vue"
import AccountLogin from "@/pages/AccountLogin.vue"
import ReportDetailsEdit from "@/pages/ReportDetailsEdit.vue"
import LocationPage from "@/pages/LocationPage.vue"
import LocationEdit from "@/pages/LocationEdit.vue"
import DeleteAccountPage from "@/pages/DeleteAccountPage.vue"
import DeleteAccountSucces from "@/pages/DeleteAccountSucces.vue"
import DefectPage from "@/pages/DefectPage.vue"
import DefectEdit from "@/pages/DefectEdit.vue"

const routes = [
    {
        path: '/',
        name: "Start",
        component: StartPage 
    },
    { 
        path: '/home',
        name: "Home",
        component: HomePage 
    },
    { 
        path: '/login', 
        name: "Login",
        component: AccountLogin 
    },
    { 
        path: '/delete-account', 
        name: "DeleteAccount",
        component: DeleteAccountPage 
    },
    { 
        path: '/delete-account/success', 
        name: "DeleteAccountSucces",
        component: DeleteAccountSucces 
    },
    { 
        path: '/members/:id', 
        name: "Edit Members",
        component: MemberEdit 
    },
    { 
        path: '/members', 
        name: "Memebers",
        component: MemberPage 
    },
    { 
        path: '/projects', 
        name: "Projects",
        component: ProjectPage 
    },
    { 
        path: '/projects/:id', 
        name: "Edit Projects",
        component: ProjectEdit 
    },
    { 
        path: '/defects', 
        name: "Defects",
        component: DefectPage 
    },
    { 
        path: '/defects/:id', 
        name: "Edit Defects",
        component: DefectEdit 
    },
    { 
        path: '/companies/:id', 
        name: "Edit Company",
        component: CompanyEdit 
    },
    { 
        path: '/companies', 
        name: "Companies",
        component: CompanyPage 
    },
    { 
        path: '/locations/:id', 
        name: "Edit Location",
        component: LocationEdit 
    },
    { 
        path: '/locations', 
        name: "Locations",
        component: LocationPage 
    },
    { 
        path: '/reports/:id', 
        name: "Edit Report",
        component: ReportEdit 
    },
    { 
        path: '/reports/:reportId/details/:id', 
        name: "Edit Report Details",
        component: ReportDetailsEdit 
    },
    { 
        path: '/reports', 
        name: "Reports",
        component: ReportPage 
    },
    { 
        path: '/settings', 
        name: "Settings",
        component: SettingPage 
    }
]

export default routes